import type React from 'react'
import {Button} from '@/components/GDS/atoms/Button'
import BaseCard from '@/components/common/BaseCard'

interface NoAccessProps {
  title?: string
  message?: string
}

/**
 * Displayed when a user has no accessible routes at all.
 * Prompts them to contact an admin to get a role assigned.
 */
const NoAccess: React.FC<NoAccessProps> = ({
  title = 'No Access',
  message = 'You do not have access to any pages. Please contact your administrator to get the appropriate role assigned.',
}) => {
  const handleLogout = () => {
    globalThis.location.href = '/logout'
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="w-full max-w-md">
        <BaseCard title="">
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <span className="material-icons mb-4 text-5xl text-gray-400">lock</span>
            <h1 className="text-title-large mb-2">{title}</h1>
            <p className="text-body-base mb-6 max-w-md">{message}</p>
            <Button variant="primary" size="medium" text="Logout" onClick={handleLogout} />
          </div>
        </BaseCard>
      </div>
    </div>
  )
}

export default NoAccess
